export const BAND_EMAIL = "lowfye50band@gmail.com"

export const STREAMING_LINKS = [
    { name: "Spotify", icon: "fab fa-spotify", href: "https://open.spotify.com/artist/72ZHgiAkpuDJC9P2C2HGZI?si=T9yidNLCQzeM20oDpu-epA" },
    { name: "Apple Music", icon: "fab fa-apple", href: "https://music.apple.com/us/artist/lowfye-50/1513025358" },
    { name: "YouTube", icon: "fab fa-youtube", href: "https://www.youtube.com/@lowfye50" },
]

export const SOCIAL_LINKS = [
    { name: "Instagram", icon: "fab fa-instagram", href: "https://www.instagram.com/lowfye50/" },
    { name: "TikTok", icon: "fab fa-tiktok", href: "https://www.tiktok.com/@lowfye50?lang=en" },
    { name: "Facebook", icon: "fab fa-facebook-f", href: "https://www.facebook.com/lowfye50/" },
]
